import { GroupList } from '@/admin/entities/group/GroupList';
import { UserList } from '@/admin/entities/user/UserList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';


export const RoleDetail = () => {

  const { entityObj } = useEntityMgr();
  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'groupsTab', label: 'Groups', content: <GroupList roleObj={entityObj} /> },
    { id: 'usersTab', label: 'Users', content: <UserList roleObj={entityObj} /> },
  ];


  return (
    <EntityDetail key={entityObj} tabSpecs={tabSpecs} />
  )
}